import AnalyticsEvent from './analytics-event';
import { Wishlist } from './segment-ecommerce-types';

export class ProductWishlistDeletedEvent extends AnalyticsEvent {
  public readonly name = 'Product Wishlist Deleted';

  constructor(public readonly properties: Wishlist) {
    super();
  }
}
